import "@fontsource/figtree";
import "@fontsource/figtree/600.css";
import styled from "styled-components";
import { theme } from "../../../theme";

const TitleUF = styled.div<{
  textalign?: string;
  color?: string;
  fontweight?: number | string;
}>`
  font-family: "Figtree", sans-serif;
  font-size: 32px;
  color: ${(props) => props.color ?? theme.colors.text};
  text-align: ${(props) => props.textalign ?? "left"};
  font-weight: ${(props) => props.fontweight ?? 600};
`;

export default TitleUF;
